var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { TemplateDrawer, TemplateDrawerContent } from 'app/domains/esigning/components/TemplateDrawer';
import { useEsigningProviders } from 'app/domains/esigning/hooks/useEsigningProviders';
import { EsigningRecipientType } from 'shared/domains/apollo/generated/types';
import { DefaultRecipientsForm } from './DefaultRecipientsForm';
import { LoadErrorAlert } from './LoadErrorAlert';
import { useComposers } from './useComposers';
import { useSetDefaultSignatories } from './useSetDefaultSignatories';
import { areComposerRecipientsEqual, areComposerRecipientsPopulated, mapDefaultApproverRecipient, mapDefaultSignerRecipient, mapDefaultViewerRecipient, } from './utils';
export function TemplateDefaultRecipientsDrawer(props) {
    var _a, _b, _c;
    const { composerIds, onClose } = props;
    const { composers, error, loading: loadingComposers } = useComposers(composerIds);
    const { loading: loadingProvider } = useEsigningProviders();
    const { setDefaultSignatories } = useSetDefaultSignatories();
    const { addToast } = useToast();
    const loading = loadingComposers || loadingProvider;
    const firstComposerName = ((_b = (_a = composers[0]) === null || _a === void 0 ? void 0 : _a.metadata[0]) === null || _b === void 0 ? void 0 : _b.name) || '';
    const subheader = composerIds.length === 1
        ? firstComposerName
        : t({
            comment: 'Manage default signing parties drawer - subheader',
            message: `${composerIds.length} selected templates`,
        });
    const isEdit = areComposerRecipientsPopulated(composers);
    const isEqual = areComposerRecipientsEqual(composers);
    const initialRecipients = isEqual ? (_c = composers[0]) === null || _c === void 0 ? void 0 : _c.defaultRecipients : [];
    const handleSubmit = (data) => __awaiter(this, void 0, void 0, function* () {
        const signatories = data.recipients
            .filter(({ type }) => type === EsigningRecipientType.Signatory)
            .map(mapDefaultSignerRecipient);
        const approvers = data.recipients
            .filter(({ type }) => type === EsigningRecipientType.Approver)
            .map(mapDefaultApproverRecipient);
        const ccRecipients = data.recipients
            .filter(({ type }) => type === EsigningRecipientType.Viewer)
            .map(mapDefaultViewerRecipient);
        try {
            yield setDefaultSignatories({ composerIds, signatories, approvers, ccRecipients });
            addToast({
                appearance: 'success',
                title: t({
                    message: 'Successfully saved default signing parties',
                    comment: 'Success message for saving default signing parties toast',
                }),
            });
            onClose();
        }
        catch (_d) {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'Could not save default signing parties',
                    comment: 'Error message for saving default signing parties toast',
                }),
            });
        }
    });
    return (<TemplateDrawer header={t({
            comment: 'Manage default signing parties drawer - header',
            message: 'Default signing parties',
        })} subheader={subheader} loading={loading} onClose={onClose}>
      {error ? (<TemplateDrawerContent>
          <LoadErrorAlert />
        </TemplateDrawerContent>) : (<DefaultRecipientsForm isEdit={isEdit} isEqual={isEqual} initialRecipients={initialRecipients} onSubmit={handleSubmit}/>)}
    </TemplateDrawer>);
}
